/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-weight: 600;
  color: var(--davinci-color-text-light, );
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-color: rgba(0, 0, 0, 0);
  border-style: hidden;
  margin: 1px;
  border-width: 1px;
  border-radius: 1rem;
  box-shadow: 0px 12px 40px 0px rgba(0, 0, 0, 0.1019607843);
  background-color: var(--davinci-color-background-input, );
}
:host header {
  display: flex;
  gap: 0.75rem;
  border-bottom-width: 1px;
  border-color: var(--davinci-color-outline-light, );
  border-bottom-style: solid;
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
  padding-left: 2rem;
  padding-right: 1.5rem;
}
:host header ::slotted(*) {
  min-width: 1rem;
  width: 1rem;
  height: 100%;
}
:host header #title {
  flex: 1 1 auto;
  min-width: 0; /* hack for avoiding overflow if text too long */
  font-size: 1.25rem;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
}
:host main {
  flex: 1 1 auto;
  overflow: hidden;
  align-self: stretch;
  justify-self: stretch;
}
:host main ::slotted(*) {
  height: 100%;
}

:host([hidden]) {
  display: none;
}

:host([state=selected]) {
  border-color: var(--davinci-color-text-lighter, );
}

:host([state=warning]) {
  border-color: var(--davinci-color-warning, );
}

:host([state=error]) {
  border-color: var(--davinci-color-error, );
}

:host([state]) {
  border-style: solid;
  margin: 0;
}

:host([no-header]) header {
  display: none;
}

.icon {
  fill: var(--davinci-color-text-on-background, );
  width: 1.125rem;
  height: 1.125rem;
  cursor: pointer;
}`;
export { style };
